module.exports = __webpack_public_path__ + "img/HotBingo_2208x1242_6.b0c42786.png";